import _ from 'underscore';
import { useCallback, useMemo, useState } from 'react';

import { PREVIEW_IMAGE_INDEX } from './consts';

const DEFAULT_AD_PREVIEW_STATE = {
  previewImageId: null,
  cropImageObj: null,
  editingPlacementType: '',
};

export const useAdPreviewState = (adData, onDataChange) => {
  const imageList = useMemo(() => _.get(adData, ['Images', 'ImageList']), [adData]);
  const selectedImageType = useMemo(() => _.get(adData, 'SelectedImageType'), [adData]);
  const [previewImagesSharedState, setPreviewImagesSharedState] = useState(DEFAULT_AD_PREVIEW_STATE);

  const openEditor = useCallback(() => {
    const matchingImage = _.findWhere(imageList[PREVIEW_IMAGE_INDEX], { type: selectedImageType });

    const imageObj = matchingImage.baseImage.clone();
    imageObj.setCropSettings(matchingImage.cropSettings);

    setPreviewImagesSharedState({ ...previewImagesSharedState, cropImageObj: imageObj });
  }, [imageList, previewImagesSharedState, selectedImageType]);

  const saveChanges = useCallback(({ cropSettings, selectedImageType: newSelectedImageType }) => {
    const updatedImageList = imageList[PREVIEW_IMAGE_INDEX].map((image) => {
      const updatedImage = image.clone();

      updatedImage.setIncluded(updatedImage.type === newSelectedImageType);

      if (updatedImage.type === newSelectedImageType) {
        updatedImage.setCropSettings(cropSettings);
      }

      return updatedImage;
    });

    onDataChange({
      data: prevData => ({
        ...prevData,
        adData: {
          ...prevData.adData,
          SelectedImageType: newSelectedImageType,
          Images: {
            ...prevData.adData.Images,
            ImageList: [updatedImageList],
          },
        },
      }),
    });

    setPreviewImagesSharedState(DEFAULT_AD_PREVIEW_STATE);
  }, [imageList, onDataChange]);

  return {
    previewImagesSharedState,
    setPreviewImagesSharedState,
    openEditor,
    saveChanges,
  };
};
